//@ts-ignore
import Board from "@asseinfo/react-kanban";
import { useQuery } from "react-query";
import "./styles.css";

import { formatCards } from "../../utils";
import { api } from "../../config";

import { Button, Checkbox, Dropdown, Modal, Skeleton } from "antd";
import "./styles.css";

import dbData from "../../backup.json";
import { SearchBar } from "../SearchBar/SearchBar";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  getProductsAssembleTime,
  updateDatabaseTickets,
} from "../../utils/helpers/ticketHelpers";
import AddTicketModal from "./AddTicketModal";
import { ImportTicketModal } from "./ImportTIcketModal";
import { DownOutlined, ExclamationCircleFilled, MoreOutlined } from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import dayjs from "dayjs";
import { CreateSingleTicketModal } from "./SingleTicketModal";
import { SearchAssemblers } from "../Shared/Components/SearchAssemblers/SearchAssemblers";
import { toast } from "react-toastify";
import { NewSearchBar } from "./NewSearchBar";
import { CheckboxChangeEvent } from "antd/lib";
import {
  ModulePermission,
  userHasPermission,
} from "../../utils/helpers/userHelpers";
import { useModal } from "../../utils/hooks/useModal";
import { ScheduleReportModal } from "./ScheduleReportModal";
import { downloadCsv, MassExportModal } from "./MassExportModal";
import { Payment } from "../Assembly/TicketModal/Payment";
import { AdditionsApprovementModal } from "../Assembly/TicketModal/AdditionsApprovement";
import { ManagementReportModal } from "./ManagementReportModal";
import { AssemblerPaymentModal } from "./AssemblerPaymentModal";
import { SalesReportModal } from "./SalesReportModal";
import { ChecklistSalesExportModal } from "./ChecklistSalesExportModal";
const { confirm } = Modal;
interface KanbanBoardProps {
  type: "checklist" | "measuring" | "assemble";
  onClick?: (id?: number) => void;
  ticketPatch?: {
    id: number;
    changes: any;
  };
}

const ColumnHeader = ({
  title,
  key,
  openConfirmModal,
  loadMoreTickets,
}: any) => {
  const handleLoadMore = () => {
    loadMoreTickets(key, skip);
    setSkip((prev) => prev + 10);
  };
  const [skip, setSkip] = useState(10);
  return (
    <div className="react-kanban-column-header flex flex-col items-center">
      {title}

      {key === "ASSEMBLE_APPROVED" && (
        <div>
          <Button type="primary" onClick={openConfirmModal}>
            Exportar Em Massa
          </Button>
        </div>
      )}
      {key === "ASSEMBLE_PENDING_SCHEDULE" && (
        <>
          <div className="flex justify-between gap-2">
            <div className="flex">
              <Checkbox />
              <p>Normal</p>
            </div>
            <div className="flex">
              <Checkbox />
              <p>Assistencia/Avulsos</p>
            </div>
          </div>
          <Button onClick={handleLoadMore}>Carregar Mais</Button>
        </>
      )}
    </div>
  );
};

export const KanbanBoard = ({ type, onClick, ticketPatch }: KanbanBoardProps) => {
  const { token, user } = useSelector((state: AuthenticationState) => state);
  const [importIsOpen, setImportIsOpen] = useState(false);
  const [mainLoading, setMainLoading] = useState(false);
  const [onOpenSingleTicketModal, setOnOpenSingleTicketModal] = useState(false);
  const {isOpen: isOpenExport, onClose: onCloseExport, onOpen: onOpenExport } = useModal()
  const [assembler, setAssembler] = useState<number>();
  const [scheduledBy, setScheduledBy] = useState<number>();
  const [loadMoreLoading, setLoadingMoreLoading] = useState(false)
  const [ticketType, setTicketType] = useState<string[]>([])
  const [checklistSaleFilters, setChecklistSaleFilters] = useState<string[]>([])
  const [pendingScheduleTotalCount, setPendingScheduleTotalCount] = useState(0)
  const [loaded, setLoaded] = useState(0)
  const shouldRefetchByFilterChange = useRef(false);
  const { isOpen, onOpen, onClose } = useModal();
  const { isOpen: isOpenPayment, onOpen: onOpenPayment, onClose: onClosePayment } = useModal();
  const { isOpen: isOpenApp, onOpen: onOpenApp, onClose: onCloseApp } = useModal();

  const { isFetching, data, isError, refetch } = useQuery(
    [`tickets/${type}/board`],
    () =>
      api(token).get(
        `tickets/${type}/board?${assembler ? `&ownerId=${assembler}` : ""}${scheduledBy ? `&scheduledById=${scheduledBy}` : ""}`
      )
  );
  const [mainData, setMainData] = useState<any[]>([]);

  useEffect(() => {
    if (!shouldRefetchByFilterChange.current) {
      shouldRefetchByFilterChange.current = true;
      return;
    }

    refetch();
  }, [assembler, scheduledBy, refetch]);

  useEffect(() => {
    if (data?.length) {
      setMainData(data);
    }
  }, [data]);

  useEffect(() => {
    if (!ticketPatch || type !== "checklist") return;

    setMainData((previous) =>
      previous.map((column) => ({
        ...column,
        cards: column.cards.map((card: any) =>
          card.id === ticketPatch.id
            ? { ...card, ...ticketPatch.changes }
            : card
        ),
      }))
    );
  }, [ticketPatch, type]);

  const backupData: any = dbData;

  const handleCheckbox= (e:CheckboxChangeEvent) => {
    const {id, checked} = e.target
    if (checked) {
      setTicketType(prev => Array.from(new Set([...prev, (id as string)])))
    } else {
      setTicketType(prev => prev.filter(item => item !== id))
    }
  }

  const handleChecklistSaleFilter = (e: CheckboxChangeEvent) => {
    const { id, checked } = e.target;
    if (checked) {
      setChecklistSaleFilters((prev) =>
        Array.from(new Set([...prev, id as string]))
      );
    } else {
      setChecklistSaleFilters((prev) => prev.filter((item) => item !== id));
    }
  };

  const filteredMainData = useMemo(() => {
    if (type !== "checklist" || !checklistSaleFilters.length) {
      return mainData;
    }

    const ticketMatchesFilters = (ticket: any) => {
      const isFullPromissory = !!ticket.isFullPromissory;
      const isBuildingInProgress = !!ticket.buildingInProgress;
      const isEffective = ticket.saleStatus === 2 && !isFullPromissory;
      const isPromissory = ticket.saleStatus === 7 && !isFullPromissory;

      return (
        (checklistSaleFilters.includes("EFFECTIVE") && isEffective) ||
        (checklistSaleFilters.includes("FULL_PROMISSORY") &&
          isFullPromissory) ||
        (checklistSaleFilters.includes("PROMISSORY") && isPromissory) ||
        (checklistSaleFilters.includes("BUILDING_IN_PROGRESS") &&
          isBuildingInProgress)
      );
    };

    return mainData.map((column) => {
      const filteredCards = column.cards.filter(ticketMatchesFilters);
      return {
        ...column,
        title: String(column.title).replace(/ - \d+$/, ` - ${filteredCards.length}`),
        cards: filteredCards,
      };
    });
  }, [checklistSaleFilters, mainData, type]);

  useEffect(() => {
    if (loaded && type === "assemble"){
      loadMoreTickets('ASSEMBLE_PENDING_SCHEDULE', 0, ticketType, true)
    }
    setLoaded(prev => prev + 1)
},[ticketType])

  const renderOptions = (data: any) => {
    let onlyCards: any = data?.map((item: any) => item.cards);
    return onlyCards?.flat().map((option: any) => {
      return {
        id: String(option.id),
        value: option.id,
        title: option.title,
        label: (
          <div key={option.id} className="flex flex-col">
            <span className="text-blue-600">{option.title}</span>
            <small>
              <b>ID Simp:</b> {option.id ?? "(Não informada)"}
            </small>
            <small>
              <b>ID Venda:</b>
              {option.saleId ? option.saleId : "(Não informada)"}
            </small>
            <small>
              <b>ID Ticket:</b>
              {option.externalId ? option.externalId : "(Não informado)"}
            </small>
          </div>
        ),
        externalId: String(option.externalId),
        saleId: String(option.saleId),
      };
    });
  };

  const handleClick = (value: any, option: any) => {
    onClick?.(option.id);
  };

  const exportAll = async () => {
    const tickets = await api(token).get(
      `tickets/assemble?status=ASSEMBLE_APPROVED&pageSize=10000`
    );
    const excel = new Excel();
    const dateFormated = dayjs().format("DD-MM-YYYY");
    excel
      .addSheet("Pagamentos")
      .addColumns([
        {
          title: "Ticket",
          dataIndex: "title",
        },
        {
          title: "Montador",
          dataIndex: "assembler",
        },
        {
          title: "Horas",
          dataIndex: "assemblyTime",
        },
        {
          title: "Valor",
          dataIndex: "value",
        },
        {
          title: "Pago?",
          dataIndex: "pago",
        },
      ])
      .addDataSource(
        tickets.tickets
          .filter((item: any) => item)
          .filter((item: any) => item.owner?.fullName)
          .map((item: any) => {
            const value =
              item.products.reduce((a: any, b: any) => a + Number(b.value), 0) *
              0.0445;
            return {
              title: item.title,
              assembler: item.owner?.fullName,
              assemblyTime: getProductsAssembleTime(item.products) + " Horas",
              value: `R$ ${value.toFixed(2)}`,
              pago: "",
            };
          })
      )
      .saveAs(`Pagamento_Em_Massa_${dateFormated}.xlsx`);
  };

  const openConfirmModal = () => {
    confirm({
      title: "Exportar Pagamento Em Massa",
      icon: <ExclamationCircleFilled />,
      content: (
        <>
          {" "}
          Exportar em massa <b>todos</b> os tickets?
        </>
      ),
      okText: "Exportar",
      centered: true,
      onOk() {
        return exportAll();
      },
      onCancel() {},
    });
  };

  const loadMoreTickets = async (
    status: string,
    skip: number,
    type?: string[],
    rewrite?: boolean
  ) => {
    try {
      setLoadingMoreLoading(true);
      const response = await api(token).get(
        `/tickets/load-more?skip=${skip}&status=${status}${
          type?.length ? `&type=${type.join(",")}` : ""
        }${assembler ? `&ownerId=${assembler}`: ''}${scheduledBy ? `&scheduledById=${scheduledBy}`: ''}`
      );
      const index =
        mainData?.findIndex((item: any) => item.key === status) ?? 0;
      console.log(data[index]);
      const tempData = [...mainData];
      if (rewrite) {
        tempData[index].cards = response.reports;
      } else {
        tempData[index].cards = Array.from(new Set([...tempData[index].cards, ...response.reports]));
      }
      setMainData(tempData);

      if (status === "ASSEMBLE_PENDING_SCHEDULE") {
        setPendingScheduleTotalCount(response.totalCount)
      }

    } catch (error) {
      toast.error("Ocorreu um erro ao carregar mais resultados");
    } finally {
      setLoadingMoreLoading(false);
    }
  };

  const handleExportPending = async () => {
       try {
         setLoadingMoreLoading(true)
         const data = await api(token).get(
           `tickets/pending-report`
         );
         downloadCsv(data);
         setAssembler(undefined)
         return;
       } catch (error) {
         toast.error("Ocorreu um erro ao gerar o relatório");
       } finally {
         setLoadingMoreLoading(false)
       }
  }

  const { isOpen: isOpenReport, onClose: onCloseReport, onOpen: onOpenReport } = useModal()
  const {onOpen: onOpenAssemblerPayments, onClose: onCloseAssemblerPayments, isOpen: isOpenAssemblerPayments} = useModal()
  const {
    isOpen: isOpenSalesReport,
    onClose: onCloseSalesReport,
    onOpen: onOpenSalesReport,
  } = useModal()
  const {
    isOpen: isOpenChecklistSalesExport,
    onClose: onCloseChecklistSalesExport,
    onOpen: onOpenChecklistSalesExport,
  } = useModal()

  const canExportChecklistSalesReport =
    userHasPermission(user, { management: ModulePermission.ADMIN }) &&
    userHasPermission(user, { checklist: ModulePermission.ADMIN });

  const canRefreshExternalTickets =
    (type === "checklist" &&
      userHasPermission(user, { checklist: ModulePermission.ADMIN })) ||
    (type === "measuring" &&
      userHasPermission(user, { measuring: ModulePermission.ADMIN }));

  const handleRefreshExternalTickets = async () => {
    if (type === "assemble") return;

    try {
      setMainLoading(true);
      await updateDatabaseTickets(token, type);
      await refetch();
      toast.success("Kanban atualizado com sucesso");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleMySchedules = () => {
    if (!user?.id) return;

    setScheduledBy((currentScheduledBy) =>
      currentScheduledBy === user.id ? undefined : user.id
    );
  };

const items = [
    {
      key: "1",
      label: "Relatório de agendamentos",
      onClick: onOpen,
      disabled: !userHasPermission(user, {assemble: ModulePermission.ADMIN})
    },
    {
      key: "2",
      label: "Adicionar Ticket Avulso",
      
      onClick: () => setOnOpenSingleTicketModal(true),
    },
    {
      key: "3",
      label: "Importar Ticket",
      onClick: () => setImportIsOpen(true),
      disabled: !userHasPermission(user, {management: ModulePermission.ADMIN})
    },
        {
      key: "4",
      label: "Relatório Gerencial",
      onClick: onOpenReport,
      disabled: !userHasPermission(user, {financial: ModulePermission.ADMIN})
    },
        {
      key: "5",
      label: "Resumo de pagamento por montador",
      onClick: onOpenAssemblerPayments,
      disabled: !userHasPermission(user, {payments: ModulePermission.ADMIN})
    },
  ];
  return (
    <>
      <SalesReportModal
        isOpen={isOpenSalesReport}
        onClose={onCloseSalesReport}
      />
      <ChecklistSalesExportModal
        isOpen={isOpenChecklistSalesExport}
        onClose={onCloseChecklistSalesExport}
      />
      <ManagementReportModal isOpen={isOpenReport} onClose={onCloseReport} />
      <AssemblerPaymentModal isOpen={isOpenAssemblerPayments} onClose={onCloseAssemblerPayments} />
      <MassExportModal isOpen={isOpenExport} onClose={onCloseExport} />
      <Payment isOpen={isOpenPayment} onClose={onClosePayment} refetch={refetch} onOpen={onOpenPayment} />
      <AdditionsApprovementModal isOpen={isOpenApp} onClose={onCloseApp} onOpen={onOpenApp} refetch={refetch} />
      <ScheduleReportModal isOpen={isOpen} onClose={onClose} />
      <CreateSingleTicketModal
        isOpen={onOpenSingleTicketModal}
        onClose={() => setOnOpenSingleTicketModal(false)}
        refetch={refetch}
        type="assemble"
      />
      <ImportTicketModal
        isOpen={importIsOpen}
        onClose={() => setImportIsOpen(false)}
        type={type}
        refetch={refetch}
      />

      <div className="w-full relative h-9">
        <div className="absolute left-0">
          <div className="flex gap-5">
            {type === 'assemble' ? (
              <NewSearchBar />
            ) : (
            <SearchBar
              placeholder="Buscar ticket..."
              options={renderOptions(isError ? backupData[type] : data)}
              onChangeFunction={handleClick}
            />
            )}
            
            {type === "measuring" && <AddTicketModal refetch={refetch} />}
            {type === "checklist" && (
              <div className="flex gap-4 items-center">
                <div className="flex items-center gap-1">
                  <Checkbox
                    id="EFFECTIVE"
                    checked={checklistSaleFilters.includes("EFFECTIVE")}
                    onChange={handleChecklistSaleFilter}
                  />
                  <p>Efetivado</p>
                </div>
                <div className="flex items-center gap-1">
                  <Checkbox
                    id="FULL_PROMISSORY"
                    checked={checklistSaleFilters.includes("FULL_PROMISSORY")}
                    onChange={handleChecklistSaleFilter}
                  />
                  <p>100% Promissória</p>
                </div>
                <div className="flex items-center gap-1">
                  <Checkbox
                    id="PROMISSORY"
                    checked={checklistSaleFilters.includes("PROMISSORY")}
                    onChange={handleChecklistSaleFilter}
                  />
                  <p>Promissória</p>
                </div>
                <div className="flex items-center gap-1">
                  <Checkbox
                    id="BUILDING_IN_PROGRESS"
                    checked={checklistSaleFilters.includes(
                      "BUILDING_IN_PROGRESS"
                    )}
                    onChange={handleChecklistSaleFilter}
                  />
                  <p>Em Obras</p>
                </div>
              </div>
            )}
            {type === "assemble" && (
              <>
                <SearchAssemblers
                  setAssembler={setAssembler}
                  assembler={assembler}
                  disabled={mainLoading}
                  onSearch={refetch}
                />
                <SearchAssemblers
                  setAssembler={setScheduledBy}
                  assembler={scheduledBy}
                  disabled={mainLoading}
                  onSearch={refetch}
                  type="Agendado por"
                />
                <Button
                  type={scheduledBy === user?.id ? "primary" : "default"}
                  onClick={handleMySchedules}
                  disabled={mainLoading || !user?.id}
                >
                  Meus Agendamentos
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="absolute flex gap-5 right-0">
          {type === "assemble" && (
            <>

        <Dropdown
          
          menu={{ items }}
          placement="bottomLeft"
        >
          <Button
            size="small"
            shape="circle"
          >
            <MoreOutlined />
          </Button>
        </Dropdown>
            </>
          )}

          {type !== "assemble" && (
            <div className="flex gap-2">
              {type === "checklist" && (
                <>
                  <Button
                    onClick={onOpenSalesReport}
                    className="font-bold"
                    type="primary"
                    disabled={!canExportChecklistSalesReport}
                  >
                    Relatório de Vendas
                  </Button>
                  <Button
                    onClick={onOpenChecklistSalesExport}
                    className="font-bold"
                    type="primary"
                    disabled={!canExportChecklistSalesReport}
                  >
                    Exportar Cupons
                  </Button>
                </>
              )}
              <Button
                onClick={handleRefreshExternalTickets}
                className="font-bold"
                type="primary"
                disabled={!canRefreshExternalTickets || mainLoading}
                loading={mainLoading}
              >
                Atualizar
              </Button>
              <Button
                onClick={() => setImportIsOpen(true)}
                className="font-bold"
                type="primary"
              >
                Importar Ticket
              </Button>
            </div>
          )}
          
        </div>
      </div>
      {isFetching ? (
        <Skeleton active />
      ) : (
        <>
          {mainLoading ? (
            <Skeleton active />
          ) : (
            <Board
              disableCardDrag
              disableColumnDrag
              renderColumnHeader={({ title, key, cards }: any) => {
                const isPendingAssemble = key === "ASSEMBLE_PENDING_SCHEDULE"
                const handleLoadMore = () => {
                  loadMoreTickets(key, cards.length, isPendingAssemble ? ticketType : undefined);
                };
                return (
                  <div className="react-kanban-column-header flex flex-col items-center">
                    {isPendingAssemble && ticketType.length ? title.replace(/\d+/ig, '') + pendingScheduleTotalCount : title}
                    {isPendingAssemble && (
                      <div>
                        <Button loading={loadMoreLoading} type="primary" onClick={handleExportPending}>
                          Exportar Todos
                        </Button>
                      </div>
                    )}


                    {key === "ASSEMBLE_APPROVED" && (
                      <Dropdown
                        trigger={["click"]}
                        menu={{
                          items: [
                            {
                              key: "export",
                              label: "Exportar em Massa",
                              onClick: onOpenExport,
                            },
                            {
                              key: "approve",
                              label: "Aprovar em Massa",
                              onClick: onOpenPayment,
                              disabled: !userHasPermission(user, {
                                payments: ModulePermission.ADMIN,
                              }),
                            },
                          ],
                        }}
                      >
                        <Button type="primary" style={{ marginBottom: 6 }}>
                          Ações em Massa <DownOutlined />
                        </Button>
                      </Dropdown>
                    )}
                    {isPendingAssemble && (
                      <>
                        <div className="flex flex-col justify-between flex-wrap max-w-full">
                          <div className="flex gap-4">
                          <div className="flex">
                            <Checkbox id="NORMAL" onChange={handleCheckbox}/>
                            <p>Normal</p>
                          </div>
                          <div className="flex">
                            <Checkbox id="ASSISTENCIA" onChange={handleCheckbox}/>
                            <p>Assistencia/Avulsos</p>
                          </div>
                          </div>
                          <div className="flex">
                            <Checkbox id="URGENTES" onChange={handleCheckbox}/>
                            <p>Alta Prioridade</p>
                          </div>
                          <div className="flex">
                            <Checkbox id="EM_OBRAS" onChange={handleCheckbox}/>
                            <p>Cliente Indisponível</p>
                          </div>
                        </div>
                      </>
                    )}
                    {type === 'assemble' && key !== "ASSEMBLE_PENDING_ADDITION_APPROVEMENT" && <Button loading={loadMoreLoading} onClick={handleLoadMore}>Carregar Mais</Button>}
                    {type === 'assemble' && key === "ASSEMBLE_PENDING_ADDITION_APPROVEMENT" && (
                      <div>
                        <Button disabled={false} type="primary" onClick={onOpenApp}>
                          Aprovar Em Massa
                        </Button>
                      </div>
                    )}
                  </div>
                );
              }}
            >
              {formatCards(
                type,
                isError ? backupData[type] : filteredMainData,
                onClick
              )}
            </Board>
          )}
        </>
      )}
    </>
  );
};
